import { useMutation, useQueryClient } from '@tanstack/react-query'

import { TasksService } from '@/services/tasks.service'

export const useStartStopTranscribing = () => {
	const queryClient = useQueryClient()

	const {
		mutateAsync: startStopTranscribing,
		isLoading: isStartStopTranscribingLoading
	} = useMutation({
		mutationKey: ['startStopTranscribing'],
		mutationFn: ({
			proxy_name,
			blocked
		}: {
			proxy_name: string
			blocked: boolean
		}) => TasksService.startStopTranscribing(proxy_name, blocked),
		onSuccess: async () => {
			await queryClient.invalidateQueries({ queryKey: ['getListeners'] })
		}
	})

	return {
		startStopTranscribing,
		isStartStopTranscribingLoading
	}
}
